<template>
  <div class="flex max-md:hidden gap-5">
    <AtomsGoogleAd
      id="div-gpt-ad-1435135522823-4"
      target="pc"
      class="w-1/2 h-[250px] shrink-0"
    />
    <AtomsGoogleAd
      id="div-gpt-ad-1435135522823-3"
      target="pc"
      class="w-1/2 h-[250px] shrink-0"
    />
  </div>
</template>
